module.exports = __webpack_public_path__ + "media/images/icons/chat-popup-old-e42b02a7ccb4caf4bffae43463e13f53.svg";